import { render, staticRenderFns } from "./RelatedQuestionsOverlay.vue?vue&type=template&id=3bfaade2&scoped=true"
import script from "./RelatedQuestionsOverlay.vue?vue&type=script&lang=js"
export * from "./RelatedQuestionsOverlay.vue?vue&type=script&lang=js"
import style0 from "./RelatedQuestionsOverlay.vue?vue&type=style&index=0&id=3bfaade2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfaade2",
  null
  
)

export default component.exports